import script from "./PsiappPlusCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PsiappPlusCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__